export const invalidField = (field: any): boolean =>
  field === undefined || field === '' || field === '0';
